import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="#E01E5A"
      stroke="#fff"
      strokeWidth={0.3}
      d="M3.632 11.375c0 .957-.783 1.74-1.741 1.74S.15 12.333.15 11.376c0-.958.783-1.741 1.74-1.741h1.742zM4.885 11.375c0-.958.783-1.741 1.74-1.741.958 0 1.741.783 1.741 1.74v4.735c0 .958-.783 1.741-1.74 1.741-.958 0-1.741-.783-1.741-1.74z"
    />
    <path
      fill="#36C5F0"
      stroke="#fff"
      strokeWidth={0.3}
      d="M6.626 3.632c-.958 0-1.741-.783-1.741-1.741S5.668.15 6.625.15c.958 0 1.741.783 1.741 1.74v1.742zM6.625 4.885c.958 0 1.741.783 1.741 1.74 0 .958-.783 1.741-1.74 1.741H1.89C.933 8.366.15 7.583.15 6.626c0-.958.783-1.742 1.74-1.742z"
    />
    <path
      fill="#2EB67D"
      stroke="#fff"
      strokeWidth={0.3}
      d="M14.368 6.625c0-.957.783-1.74 1.741-1.74s1.741.783 1.741 1.74c0 .958-.783 1.741-1.74 1.741h-1.742zM13.115 6.625c0 .958-.783 1.741-1.74 1.741-.958 0-1.741-.783-1.741-1.74V1.89c0-.958.783-1.741 1.74-1.741.958 0 1.741.783 1.741 1.74z"
    />
    <path
      fill="#ECB22E"
      stroke="#fff"
      strokeWidth={0.3}
      d="M11.375 14.368c.957 0 1.74.783 1.74 1.741s-.783 1.741-1.74 1.741c-.958 0-1.741-.783-1.741-1.74v-1.742zM11.375 13.116c-.958 0-1.741-.784-1.741-1.741s.783-1.741 1.74-1.741h4.735c.958 0 1.74.783 1.74 1.74 0 .958-.782 1.742-1.74 1.742z"
    />
  </svg>
);
export default SvgSlack;
